import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Util } from '../../../../../utils/util';
import { PixQrCodeDynamicService } from '../../../copy-and-paste/qr-code-dynamic/qr-code-dynamic.service';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { ETipoOperacao, PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { PixPaymentKeyService } from '../../../payment-key/payment-key.service';
import { WithdrawChangeService } from '../../service/withdraw-change.service';

@Component({
	selector: 'app-resume',
	templateUrl: './resume.component.html',
	styleUrls: ['./resume.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeResumeComponent implements OnInit {
	form: FormGroup;
	pixQrCodeReturn: PixQrCodeReturn;
	pixPaymentFavored: PixPaymentFavoredView;

	get isDynamicPix(): boolean {
		if (this.pixQrCodeReturn) {
			return true;
		}

		return false;
	}

	get isWithdraw(): boolean {
		if (this.pixQrCodeReturn && this.pixQrCodeReturn.qrCodeDinamico) {
			return this.pixQrCodeReturn.qrCodeDinamico.tipoOperacao === ETipoOperacao.SAQUE;
		}

		if (this.pixPaymentKeyService.getSelectedPixPaymentFavoredView()) {
			return this.pixPaymentKeyService.getSelectedPixPaymentFavoredView().tipoOperacao === ETipoOperacao.SAQUE;
		}
	}

	get favoredName(): string {
		if (this.isDynamicPix) {
			return this.pixQrCodeReturn.conta.nome;
		}

		return this.pixPaymentFavored.nome;
	}

	get ispbName(): string {
		if (this.isDynamicPix) {
			return this.pixQrCodeReturn.conta.iSPBNome;
		}

		return this.pixPaymentFavored.iSPBNome;
	}

	get pixKeyType(): PixKeyType {
		if (this.isDynamicPix) {
			return this.pixQrCodeReturn.chavePix.tipoChave;
		}

		return this.pixPaymentFavored.tipoChave;
	}

	get transferValue(): string {
		if (this.isDynamicPix) {
			return this.pixQrCodeReturn.valor.toString();
		}

		return this.pixPaymentFavored.valorQrCode.toString();
	}

	get purchaseValue(): string {
		return this.pixQrCodeReturn.qrCodeDinamico.troco.compra.toString();
	}

	get changeValue(): string {
		return this.pixQrCodeReturn.qrCodeDinamico.troco.troca.toString();
	}

	get date(): string {
		if (this.isDynamicPix) {
			return this.pixQrCodeReturn.qrCodeDinamico.calendario.dataApresentacao;
		}

		return 'Hoje';
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	constructor(
		private router: Router,
		private formBuilder: FormBuilder,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private withdrawChangeService: WithdrawChangeService,
		private pixPaymentKeyService: PixPaymentKeyService
	) { }

	ngOnInit(): void {
		this.buildForm();

		this.pixQrCodeReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.pixPaymentFavored = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();

	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	buildForm() {
		const value = this.withdrawChangeService.getDescription() ? this.withdrawChangeService.getDescription() : '';

		this.form = this.formBuilder.group({
			description: [value, [Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)]]
		});
	}

	generate = () => {
		this.withdrawChangeService
			.setDescription(this.form.get('description').value);

		this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/assinatura']);
	}

	goBack = () => this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/valor-data']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/copy-and-paste/resume/resume.component.ts